module.exports = __webpack_public_path__ + "img/profilecard.1d1e28b6.svg";